module.exports = __webpack_public_path__ + "c6bbf47d834b5cfa71efb75a8f522ac9.svg";